import { Component } from '@angular/core';

import { SiAuthenticationService } from '@strategic-insights/ng-authentication';

declare var $: any;

@Component({
  selector: 'si-customer-access',
  templateUrl: './si-customer-access.component.html',
  styleUrls: ['./si-customer-access.component.scss']
})
export class SiCustomerAccessComponent {
  customerList: any;
  selectedCustomer: any;
  isMoreCustomers: any;

  constructor(private siAuthenticationService: SiAuthenticationService) {
    this.customerList = this.siAuthenticationService.getCustomerList().sort();
    // this.selectedCustomer =  this.siAuthenticationService.getActiveCustomer();
    this.isMoreCustomers = (this.customerList.length > 12) ? true : false;

    $('#siCustomerAccessModal').modal({
      backdrop: 'static',
      keyboard: false,
      focus: true,
      show: true
    });

  }

  formatName(name) {
    if (name === 'DnP') {
      return name.replace('n', '&');
    }
    return name;
  }

  submit() {
    this.siAuthenticationService.setActiveCustomer(this.selectedCustomer);
  }

  setSelectedCustomer(selectedCustomer: string) {
    this.selectedCustomer = selectedCustomer;
  }

}
